import React, { useState } from "react";
import { MORNING_PRACTICES, MORNING_SYSTEM_SIZE } from "./data.js";

export default function MorningSystemStage({ onComplete }) {
  const [selected, setSelected] = useState([]);

  const toggle = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= MORNING_SYSTEM_SIZE) return prev;
      return [...prev, id];
    });
  };

  const canContinue = selected.length === MORNING_SYSTEM_SIZE;

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>BUILD YOUR MORNING SYSTEM</span>
        <span>
          {selected.length}/{MORNING_SYSTEM_SIZE} CHOSEN
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        A goal is a destination. A system is what actually moves you there on the days you don't
        feel like it. Pick exactly {MORNING_SYSTEM_SIZE} — not all six. Fewer things, done daily,
        beat a long list done once.
      </p>

      <div className="mb-6 space-y-2">
        {MORNING_PRACTICES.map((p) => {
          const isSelected = selected.includes(p.id);
          const atCapAndUnselected = !isSelected && selected.length >= MORNING_SYSTEM_SIZE;
          return (
            <button
              key={p.id}
              onClick={() => toggle(p.id)}
              disabled={atCapAndUnselected}
              className={`flex w-full items-center gap-3 border-2 px-4 py-3 text-left transition-colors ${
                isSelected
                  ? "border-lime bg-lime/10"
                  : atCapAndUnselected
                  ? "cursor-not-allowed border-mist/10 opacity-40"
                  : "border-mist/20 hover:border-mist/50"
              }`}
            >
              <span className="text-xl">{p.icon}</span>
              <span className="flex-1">
                <span className={`block font-display text-[9px] uppercase ${isSelected ? "text-lime" : "text-mist"}`}>
                  {p.label}
                </span>
                <span className="mt-0.5 block text-[11px] text-mist/50">{p.description}</span>
              </span>
              <span className={`font-display text-[10px] ${isSelected ? "text-lime" : "text-mist/20"}`}>
                {isSelected ? "✔" : "—"}
              </span>
            </button>
          );
        })}
      </div>

      <button
        onClick={() => onComplete({ practices: selected })}
        disabled={!canContinue}
        className="btn-magenta w-full disabled:opacity-30"
      >
        {canContinue ? "LOCK IN YOUR SYSTEM ▶" : `PICK ${MORNING_SYSTEM_SIZE - selected.length} MORE TO CONTINUE`}
      </button>
    </div>
  );
}
